import Banner from './components/ui/Banner'

export default function () {
  return { component: Banner }
}
